export const RUN_SEARCH_DELAY = 500;
